/** Uniform thumbnail box on catalog fiche (strip under main image + related accordion). */
export const CATALOG_THUMBNAIL_MARKER = "catalog-thumbnail-media";
export const CATALOG_THUMBNAIL_BOX_CLASS =
  "flex h-[100px] w-[100px] shrink-0 items-center justify-center overflow-hidden";
export const CATALOG_THUMBNAIL_IMAGE_CLASS =
  `${CATALOG_THUMBNAIL_MARKER} h-full w-full max-h-full max-w-full object-contain object-center cursor-pointer`;
export const CATALOG_THUMBNAIL_COLUMN_CLASS =
  "flex flex-col items-center gap-2 text-left w-[100px]";

/** Main hero on catalog fiche detail — full column width, natural height. */
export const CATALOG_FICHE_MAIN_MEDIA_MARKER = "catalog-fiche-main-media";
export const CATALOG_FICHE_MAIN_MEDIA_WRAPPER_CLASS =
  "w-full flex items-center justify-center";
export const CATALOG_FICHE_MAIN_MEDIA_CLASS =
  `${CATALOG_FICHE_MAIN_MEDIA_MARKER} block h-auto w-full max-w-full object-contain object-top cursor-pointer`;

export function isVideoLikeAttachment(
  attachment: { kind?: string } | null | undefined,
): boolean {
  return attachment?.kind === "video" || attachment?.kind === "embed";
}
